// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file common/v1/merchant_settings.proto (package common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Struct } from "../../google/protobuf/struct_pb";
import { CardNetwork, CardType, DebitAcceptanceType, MerchantSettingsSource, Money, PaymentGatewayType } from "./common_pb";
import { Date } from "../../google/type/date_pb";

/**
 * Defines product types.
 *
 * @generated from enum common.v1.ProductType
 */
export const ProductType = proto3.makeEnum(
  "common.v1.ProductType",
  [
    {no: 0, name: "PRODUCT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PRODUCT_TYPE_PHYSICAL", localName: "PHYSICAL"},
    {no: 2, name: "PRODUCT_TYPE_DIGITAL", localName: "DIGITAL"},
    {no: 3, name: "PRODUCT_TYPE_PHYSICAL_AND_DIGITAL", localName: "PHYSICAL_AND_DIGITAL"},
  ],
);

/**
 * @generated from enum common.v1.MerchantSettingsStatus
 */
export const MerchantSettingsStatus = proto3.makeEnum(
  "common.v1.MerchantSettingsStatus",
  [
    {no: 0, name: "MERCHANT_SETTINGS_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MERCHANT_SETTINGS_STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 2, name: "MERCHANT_SETTINGS_STATUS_DRAFT", localName: "DRAFT"},
    {no: 3, name: "MERCHANT_SETTINGS_STATUS_INACTIVE", localName: "INACTIVE"},
    {no: 4, name: "MERCHANT_SETTINGS_STATUS_PENDING", localName: "PENDING"},
    {no: 5, name: "MERCHANT_SETTINGS_STATUS_DELETED", localName: "DELETED"},
  ],
);

/**
 * defines expiration date format for Card Payment method.
 *
 * @generated from enum common.v1.ExpirationDateFormat
 */
export const ExpirationDateFormat = proto3.makeEnum(
  "common.v1.ExpirationDateFormat",
  [
    {no: 0, name: "EXPIRATION_DATE_FORMAT_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "EXPIRATION_DATE_FORMAT_SINGLE_INPUT", localName: "SINGLE_INPUT"},
    {no: 2, name: "EXPIRATION_DATE_FORMAT_SEPARATE_DROPDOWN_INPUT", localName: "SEPARATE_DROPDOWN_INPUT"},
  ],
);

/**
 * Defined the status for a Merchant domain.
 *
 * @generated from enum common.v1.DomainStatusWithApple
 */
export const DomainStatusWithApple = proto3.makeEnum(
  "common.v1.DomainStatusWithApple",
  [
    {no: 0, name: "DOMAIN_STATUS_WITH_APPLE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DOMAIN_STATUS_WITH_APPLE_UNVERIFIED", localName: "UNVERIFIED"},
    {no: 2, name: "DOMAIN_STATUS_WITH_APPLE_VERIFIED", localName: "VERIFIED"},
  ],
);

/**
 * Enum for PayPal button colors
 * https://developer.paypal.com/docs/multiparty/checkout/standard/customize/buttons-style-guide/#color
 *
 * @generated from enum common.v1.PayPalButtonColor
 */
export const PayPalButtonColor = proto3.makeEnum(
  "common.v1.PayPalButtonColor",
  [
    {no: 0, name: "PAY_PAL_BUTTON_COLOR_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAY_PAL_BUTTON_COLOR_GOLD", localName: "GOLD"},
    {no: 2, name: "PAY_PAL_BUTTON_COLOR_BLUE", localName: "BLUE"},
    {no: 3, name: "PAY_PAL_BUTTON_COLOR_SILVER", localName: "SILVER"},
    {no: 4, name: "PAY_PAL_BUTTON_COLOR_WHITE", localName: "WHITE"},
    {no: 5, name: "PAY_PAL_BUTTON_COLOR_BLACK", localName: "BLACK"},
  ],
);

/**
 * Enum for PayPal button text
 * https://developer.paypal.com/docs/multiparty/checkout/standard/customize/buttons-style-guide/#label
 *
 * @generated from enum common.v1.PayPalButtonLabel
 */
export const PayPalButtonLabel = proto3.makeEnum(
  "common.v1.PayPalButtonLabel",
  [
    {no: 0, name: "PAY_PAL_BUTTON_LABEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAY_PAL_BUTTON_LABEL_DEFAULT", localName: "DEFAULT"},
    {no: 2, name: "PAY_PAL_BUTTON_LABEL_CHECKOUT", localName: "CHECKOUT"},
    {no: 3, name: "PAY_PAL_BUTTON_LABEL_BUY_NOW", localName: "BUY_NOW"},
    {no: 4, name: "PAY_PAL_BUTTON_LABEL_PAY_WITH", localName: "PAY_WITH"},
  ],
);

/**
 * defines masking for PAN.
 *
 * @generated from enum common.v1.PaymentAccountFieldMask
 */
export const PaymentAccountFieldMask = proto3.makeEnum(
  "common.v1.PaymentAccountFieldMask",
  [
    {no: 0, name: "PAYMENT_ACCOUNT_FIELD_MASK_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAYMENT_ACCOUNT_FIELD_MASK_ALL_DIGITS_EXCEPT_LAST_4", localName: "ALL_DIGITS_EXCEPT_LAST_4"},
  ],
);

/**
 * Defines the merchant integration type
 *
 * @generated from enum common.v1.IntegrationType
 */
export const IntegrationType = proto3.makeEnum(
  "common.v1.IntegrationType",
  [
    {no: 0, name: "INTEGRATION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "INTEGRATION_TYPE_HPP", localName: "HPP"},
    {no: 2, name: "INTEGRATION_TYPE_DROP_IN", localName: "DROP_IN"},
    {no: 3, name: "INTEGRATION_TYPE_HOSTED_FIELDS", localName: "HOSTED_FIELDS"},
    {no: 4, name: "INTEGRATION_TYPE_CARTLESS_PROFILE", localName: "CARTLESS_PROFILE"},
  ],
);

/**
 * Defines the Layout for HPP/Drop In
 *
 * @generated from enum common.v1.Layout
 */
export const Layout = proto3.makeEnum(
  "common.v1.Layout",
  [
    {no: 0, name: "LAYOUT_DESIGN_UNSPECIFIED"},
    {no: 1, name: "LAYOUT_1"},
    {no: 2, name: "LAYOUT_2"},
    {no: 3, name: "LAYOUT_3"},
    {no: 4, name: "LAYOUT_4"},
    {no: 5, name: "LAYOUT_5"},
  ],
);

/**
 * Defines the products/services offered
 *
 * @generated from enum common.v1.IndustryType
 */
export const IndustryType = proto3.makeEnum(
  "common.v1.IndustryType",
  [
    {no: 0, name: "INDUSTRY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "INDUSTRY_TYPE_GROCERY", localName: "GROCERY"},
    {no: 2, name: "INDUSTRY_TYPE_APPAREL", localName: "APPAREL"},
    {no: 3, name: "INDUSTRY_TYPE_ELECTRONICS", localName: "ELECTRONICS"},
    {no: 4, name: "INDUSTRY_TYPE_HARDWARE", localName: "HARDWARE"},
    {no: 5, name: "INDUSTRY_TYPE_STREAMING", localName: "STREAMING"},
    {no: 6, name: "INDUSTRY_TYPE_PHARMACY", localName: "PHARMACY"},
    {no: 7, name: "INDUSTRY_TYPE_VARIOUS", localName: "VARIOUS"},
    {no: 8, name: "INDUSTRY_TYPE_AGRICULTURAL_SERVICES", localName: "AGRICULTURAL_SERVICES"},
    {no: 9, name: "INDUSTRY_TYPE_CONTRACTED_SERVICES", localName: "CONTRACTED_SERVICES"},
    {no: 10, name: "INDUSTRY_TYPE_TRANSPORTATION_SERVICES", localName: "TRANSPORTATION_SERVICES"},
    {no: 11, name: "INDUSTRY_TYPE_UTILITY_SERVICES", localName: "UTILITY_SERVICES"},
    {no: 12, name: "INDUSTRY_TYPE_RETAIL_OUTLET_SERVICES", localName: "RETAIL_OUTLET_SERVICES"},
    {no: 13, name: "INDUSTRY_TYPE_CLOTHING_STORES", localName: "CLOTHING_STORES"},
    {no: 14, name: "INDUSTRY_TYPE_MISCELLANEOUS_STORES", localName: "MISCELLANEOUS_STORES"},
    {no: 15, name: "INDUSTRY_TYPE_BUSINESS_SERVICES", localName: "BUSINESS_SERVICES"},
    {no: 16, name: "INDUSTRY_TYPE_PROFESSIONAL_SERVICES_AND_MEMBERSHIP_ORGANIZATIONS", localName: "PROFESSIONAL_SERVICES_AND_MEMBERSHIP_ORGANIZATIONS"},
    {no: 17, name: "INDUSTRY_TYPE_GOVERNMENT_SERVICES", localName: "GOVERNMENT_SERVICES"},
  ],
);

/**
 * Defines possible outcomes of the timeout during fraud check.
 *
 * @generated from enum common.v1.FraudCheckTimeoutHandlingMode
 */
export const FraudCheckTimeoutHandlingMode = proto3.makeEnum(
  "common.v1.FraudCheckTimeoutHandlingMode",
  [
    {no: 0, name: "FRAUD_CHECK_TIMEOUT_HANDLING_MODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FRAUD_CHECK_TIMEOUT_HANDLING_MODE_PASSED", localName: "PASSED"},
    {no: 2, name: "FRAUD_CHECK_TIMEOUT_HANDLING_MODE_DECLINED", localName: "DECLINED"},
  ],
);

/**
 * Defines possible outcomes when fraud check is in review.
 *
 * @generated from enum common.v1.FraudCheckInReviewHandlingMode
 */
export const FraudCheckInReviewHandlingMode = proto3.makeEnum(
  "common.v1.FraudCheckInReviewHandlingMode",
  [
    {no: 0, name: "FRAUD_CHECK_IN_REVIEW_HANDLING_MODE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FRAUD_CHECK_IN_REVIEW_HANDLING_MODE_PASSED", localName: "PASSED"},
    {no: 2, name: "FRAUD_CHECK_IN_REVIEW_HANDLING_MODE_DECLINED", localName: "DECLINED"},
  ],
);

/**
 * Defines possible values for sending fraud check data.
 *
 * @generated from enum common.v1.FraudCheckData
 */
export const FraudCheckData = proto3.makeEnum(
  "common.v1.FraudCheckData",
  [
    {no: 0, name: "FRAUD_CHECK_DATA_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FRAUD_CHECK_DATA_NONE", localName: "NONE"},
    {no: 2, name: "FRAUD_CHECK_DATA_SHORT_RESPONSE", localName: "SHORT_RESPONSE"},
    {no: 3, name: "FRAUD_CHECK_DATA_LONG_RESPONSE", localName: "LONG_RESPONSE"},
  ],
);

/**
 * @generated from enum common.v1.PaymentButtonName
 */
export const PaymentButtonName = proto3.makeEnum(
  "common.v1.PaymentButtonName",
  [
    {no: 0, name: "PAYMENT_BUTTON_NAME_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PAYMENT_BUTTON_NAME_PLACE_ORDER", localName: "PLACE_ORDER"},
    {no: 2, name: "PAYMENT_BUTTON_NAME_PAY_NOW", localName: "PAY_NOW"},
    {no: 3, name: "PAYMENT_BUTTON_NAME_SUBMIT", localName: "SUBMIT"},
    {no: 4, name: "PAYMENT_BUTTON_NAME_CONTINUE", localName: "CONTINUE"},
    {no: 5, name: "PAYMENT_BUTTON_NAME_PURCHASE", localName: "PURCHASE"},
    {no: 6, name: "PAYMENT_BUTTON_NAME_SAVE", localName: "SAVE"},
  ],
);

/**
 * Defines the supported languages by checkout
 *
 * @generated from enum common.v1.SupportedLanguages
 */
export const SupportedLanguages = proto3.makeEnum(
  "common.v1.SupportedLanguages",
  [
    {no: 0, name: "SUPPORTED_LANGUAGES_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SUPPORTED_LANGUAGES_EN_US", localName: "EN_US"},
    {no: 2, name: "SUPPORTED_LANGUAGES_ES_US", localName: "ES_US"},
  ],
);

/**
 * Defines the status of the experiment.
 *
 * @generated from enum common.v1.ExperimentStatus
 */
export const ExperimentStatus = proto3.makeEnum(
  "common.v1.ExperimentStatus",
  [
    {no: 0, name: "EXPERIMENT_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "EXPERIMENT_STATUS_NOT_STARTED", localName: "NOT_STARTED"},
    {no: 2, name: "EXPERIMENT_STATUS_IN_PROGRESS", localName: "IN_PROGRESS"},
    {no: 3, name: "EXPERIMENT_STATUS_COMPLETED", localName: "COMPLETED"},
    {no: 4, name: "EXPERIMENT_STATUS_CANCELLED", localName: "CANCELLED"},
  ],
);

/**
 * Defines merchant settings.
 *
 * @generated from message common.v1.MerchantSettings
 */
export const MerchantSettings = proto3.makeMessageType(
  "common.v1.MerchantSettings",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "payment_gateway_mid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(MerchantSettingsStatus) },
    { no: 5, name: "active_from", kind: "message", T: Timestamp },
    { no: 6, name: "merchant_display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "ui_settings", kind: "message", T: UISettings },
    { no: 9, name: "language_config", kind: "message", T: Struct },
    { no: 11, name: "industry_types", kind: "enum", T: proto3.getEnumType(IndustryType), repeated: true },
    { no: 12, name: "product_type", kind: "enum", T: proto3.getEnumType(ProductType), repeated: true },
    { no: 13, name: "supported_card_networks", kind: "enum", T: proto3.getEnumType(CardNetwork), repeated: true },
    { no: 14, name: "supported_card_types", kind: "enum", T: proto3.getEnumType(CardType), repeated: true },
    { no: 15, name: "fraud_check", kind: "message", T: FraudCheck },
    { no: 16, name: "supported_payment_gateway_types", kind: "enum", T: proto3.getEnumType(PaymentGatewayType), repeated: true },
    { no: 17, name: "provide_cti_data", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "safetech_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "fraud_check_timeout_handling_mode", kind: "enum", T: proto3.getEnumType(FraudCheckTimeoutHandlingMode) },
    { no: 21, name: "created_at", kind: "message", T: Timestamp },
    { no: 22, name: "updated_at", kind: "message", T: Timestamp },
    { no: 23, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "integration_type", kind: "enum", T: proto3.getEnumType(IntegrationType) },
    { no: 27, name: "payment_methods", kind: "message", T: PaymentMethods },
    { no: 28, name: "layout", kind: "enum", T: proto3.getEnumType(Layout) },
    { no: 29, name: "orders_on_hpp", kind: "message", T: OrdersOnHpp },
    { no: 30, name: "payment_max_retries_allowed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "notification_subscription", kind: "message", T: NotificationSubscription },
    { no: 33, name: "abandoned_order_ttl", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "payment_button_name", kind: "enum", T: proto3.getEnumType(PaymentButtonName) },
    { no: 36, name: "address_autocomplete_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 38, name: "supported_ship_to_country_region", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 39, name: "single_page_app_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 40, name: "order_mandates", kind: "message", T: Mandate, repeated: true },
    { no: 41, name: "security_settings", kind: "message", T: SecuritySettings },
    { no: 42, name: "page_header", kind: "message", T: PageHeader },
    { no: 43, name: "brand_experience", kind: "message", T: Struct },
    { no: 44, name: "l2_l3_data_config", kind: "message", T: L2L3DataConfig },
    { no: 45, name: "jpmc_wallet_program_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 46, name: "billing_address_country_restriction", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 50, name: "default_settings", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 51, name: "acquirer_tokenization_enabled_indicator", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 52, name: "segment", kind: "message", T: Segment },
    { no: 53, name: "platform_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 54, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 55, name: "tax_integration", kind: "message", T: TaxIntegration },
    { no: 56, name: "surcharge_fee_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 57, name: "merchant_accepted_domains", kind: "message", T: MerchantAcceptedDomains },
    { no: 58, name: "source", kind: "enum", T: proto3.getEnumType(MerchantSettingsSource), opt: true },
  ],
);

/**
 * merchant segment
 *
 * @generated from message common.v1.Segment
 */
export const Segment = proto3.makeMessageType(
  "common.v1.Segment",
  () => [
    { no: 1, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * merchant segment payload
 *
 * @generated from message common.v1.CreateSegmentPayload
 */
export const CreateSegmentPayload = proto3.makeMessageType(
  "common.v1.CreateSegmentPayload",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "segment_id_to_copy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * UI Settings to be used by FE.
 *
 * @generated from message common.v1.UISettings
 */
export const UISettings = proto3.makeMessageType(
  "common.v1.UISettings",
  () => [
    { no: 1, name: "custom_theme", kind: "message", T: Struct },
    { no: 2, name: "form_config", kind: "message", T: Struct },
  ],
);

/**
 * Describes all the Supported Method of Payments.
 *
 * @generated from message common.v1.PaymentMethods
 */
export const PaymentMethods = proto3.makeMessageType(
  "common.v1.PaymentMethods",
  () => [
    { no: 1, name: "card_payment_method", kind: "message", T: CardPaymentMethod },
    { no: 2, name: "wallet_payment_method", kind: "message", T: WalletPaymentMethod },
    { no: 3, name: "ecp_payment_method", kind: "message", T: EcpPaymentMethod },
    { no: 4, name: "sepa_payment_method", kind: "message", T: SepaPaymentMethod },
    { no: 5, name: "alt_payment_method", kind: "message", T: AltPaymentMethod },
    { no: 6, name: "pay_by_bank_payment_method", kind: "message", T: PayByBankPaymentMethod },
    { no: 7, name: "gift_card_payment_method", kind: "message", T: GiftCardPaymentMethod },
  ],
);

/**
 * Details about Card Method of Payment.
 * NextId: 15
 *
 * @generated from message common.v1.CardPaymentMethod
 */
export const CardPaymentMethod = proto3.makeMessageType(
  "common.v1.CardPaymentMethod",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "security_code_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "payment_account_field_mask", kind: "enum", T: proto3.getEnumType(PaymentAccountFieldMask) },
    { no: 4, name: "supported_cards", kind: "message", T: SupportedCards, repeated: true },
    { no: 5, name: "mandate", kind: "message", T: Mandate },
    { no: 6, name: "billing_address_collection", kind: "message", T: BillingAddressCollection },
    { no: 7, name: "supported_debit_method", kind: "message", T: CardPaymentMethod_SupportedDebitMethod },
    { no: 8, name: "capture_security_code_on_card_update", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "capture_security_code_on_pay_with_profile", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "collect_name_on_card", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "expiration_date_format", kind: "enum", T: proto3.getEnumType(ExpirationDateFormat) },
    { no: 12, name: "collect_consent_to_store_for_future_payments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "expiry_date_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Pinless Debit Payment Settings
 *
 * @generated from message common.v1.CardPaymentMethod.SupportedDebitMethod
 */
export const CardPaymentMethod_SupportedDebitMethod = proto3.makeMessageType(
  "common.v1.CardPaymentMethod.SupportedDebitMethod",
  () => [
    { no: 1, name: "pinless_debit_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "debit_acceptance_type", kind: "enum", T: proto3.getEnumType(DebitAcceptanceType) },
  ],
  {localName: "CardPaymentMethod_SupportedDebitMethod"},
);

/**
 * Settings for supported cards of some specific card network.
 *
 * @generated from message common.v1.SupportedCards
 */
export const SupportedCards = proto3.makeMessageType(
  "common.v1.SupportedCards",
  () => [
    { no: 2, name: "network", kind: "enum", T: proto3.getEnumType(CardNetwork) },
    { no: 3, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "digital_tokenization_enabled_indicator", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "token_requestor_identifier_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * Details about Wallet Payment type.
 *
 * @generated from message common.v1.WalletPaymentMethod
 */
export const WalletPaymentMethod = proto3.makeMessageType(
  "common.v1.WalletPaymentMethod",
  () => [
    { no: 1, name: "apple_pay", kind: "message", T: ApplePay },
    { no: 2, name: "google_pay", kind: "message", T: GooglePay },
    { no: 3, name: "paze", kind: "message", T: Paze },
  ],
);

/**
 * @generated from message common.v1.Alipay
 */
export const Alipay = proto3.makeMessageType(
  "common.v1.Alipay",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Apple Pay Wallet Settings.
 *
 * @generated from message common.v1.ApplePay
 */
export const ApplePay = proto3.makeMessageType(
  "common.v1.ApplePay",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "merchant_domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "apple_pay_button", kind: "message", T: ApplePayButton },
    { no: 6, name: "domains", kind: "message", T: MerchantDomain, repeated: true },
    { no: 7, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Stores Merchant domain information.
 *
 * @generated from message common.v1.MerchantDomain
 */
export const MerchantDomain = proto3.makeMessageType(
  "common.v1.MerchantDomain",
  () => [
    { no: 1, name: "domain_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain_status_with_apple", kind: "enum", T: proto3.getEnumType(DomainStatusWithApple) },
  ],
);

/**
 * PayPal Settings.
 *
 * @generated from message common.v1.Paypal
 */
export const Paypal = proto3.makeMessageType(
  "common.v1.Paypal",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "button_color", kind: "enum", T: proto3.getEnumType(PayPalButtonColor) },
    { no: 4, name: "button_label", kind: "enum", T: proto3.getEnumType(PayPalButtonLabel) },
    { no: 5, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * WeChatPay Wallet Settings.
 *
 * @generated from message common.v1.WechatPay
 */
export const WechatPay = proto3.makeMessageType(
  "common.v1.WechatPay",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Apple Pay Button Styling configuration
 *
 * @generated from message common.v1.ApplePayButton
 */
export const ApplePayButton = proto3.makeMessageType(
  "common.v1.ApplePayButton",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "button_style", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Google Pay Wallet Settings.
 *
 * @generated from message common.v1.GooglePay
 */
export const GooglePay = proto3.makeMessageType(
  "common.v1.GooglePay",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "google_pay_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "google_pay_merchant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "gateway", kind: "enum", T: proto3.getEnumType(GooglePay_Gateway) },
    { no: 5, name: "gateway_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "mandate", kind: "message", T: Mandate },
    { no: 7, name: "google_pay_button", kind: "message", T: GooglePay_GooglePayButton },
    { no: 8, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * defines gateway to be used for GooglePay
 *
 * @generated from enum common.v1.GooglePay.Gateway
 */
export const GooglePay_Gateway = proto3.makeEnum(
  "common.v1.GooglePay.Gateway",
  [
    {no: 0, name: "GATEWAY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "GATEWAY_CHASE", localName: "CHASE"},
  ],
);

/**
 * defines the settings of the Google Pay Button.
 *
 * @generated from message common.v1.GooglePay.GooglePayButton
 */
export const GooglePay_GooglePayButton = proto3.makeMessageType(
  "common.v1.GooglePay.GooglePayButton",
  () => [
    { no: 1, name: "button_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "button_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "GooglePay_GooglePayButton"},
);

/**
 * Paze Wallet Settings.
 *
 * @generated from message common.v1.Paze
 */
export const Paze = proto3.makeMessageType(
  "common.v1.Paze",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Details about ECP Payment type.
 *
 * @generated from message common.v1.EcpPaymentMethod
 */
export const EcpPaymentMethod = proto3.makeMessageType(
  "common.v1.EcpPaymentMethod",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "confirm_account_number", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "confirm_routing_number", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "mandate", kind: "message", T: Mandate },
    { no: 5, name: "billing_address_collection", kind: "message", T: BillingAddressCollection },
    { no: 6, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "collect_consent_to_store_for_future_payments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Details about SEPA Payment type.
 *
 * @generated from message common.v1.SepaPaymentMethod
 */
export const SepaPaymentMethod = proto3.makeMessageType(
  "common.v1.SepaPaymentMethod",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "mandate", kind: "message", T: Mandate },
    { no: 3, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "billing_address_collection", kind: "message", T: BillingAddressCollection },
    { no: 5, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "collect_consent_to_store_for_future_payments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Details about Pay By Bank Payment type.
 *
 * @generated from message common.v1.PayByBankPaymentMethod
 */
export const PayByBankPaymentMethod = proto3.makeMessageType(
  "common.v1.PayByBankPaymentMethod",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "experience_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "external_merchant_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mandate", kind: "message", T: Mandate },
    { no: 5, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * Details about alternate payment method types.
 *
 * @generated from message common.v1.AltPaymentMethod
 */
export const AltPaymentMethod = proto3.makeMessageType(
  "common.v1.AltPaymentMethod",
  () => [
    { no: 1, name: "ideal", kind: "message", T: Ideal },
    { no: 2, name: "sofort", kind: "message", T: Sofort },
    { no: 3, name: "giropay", kind: "message", T: Giropay },
    { no: 4, name: "trustly", kind: "message", T: Trustly },
    { no: 5, name: "alipay", kind: "message", T: Alipay },
    { no: 6, name: "wechat_pay", kind: "message", T: WechatPay },
    { no: 7, name: "paypal", kind: "message", T: Paypal },
  ],
);

/**
 * Ideal Alt Mops Settings.
 *
 * @generated from message common.v1.Ideal
 */
export const Ideal = proto3.makeMessageType(
  "common.v1.Ideal",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Sofort Alt Mops Settings.
 * sofort is deprecated TODO remove in future sprints
 *
 * @generated from message common.v1.Sofort
 */
export const Sofort = proto3.makeMessageType(
  "common.v1.Sofort",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * GiroPay Alt Mops Settings.
 * deprecated  TODO remove in future sprints
 *
 * @generated from message common.v1.Giropay
 */
export const Giropay = proto3.makeMessageType(
  "common.v1.Giropay",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Trustly Alt Mops Settings.
 *
 * @generated from message common.v1.Trustly
 */
export const Trustly = proto3.makeMessageType(
  "common.v1.Trustly",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Details about GiftCard payment type
 *
 * @generated from message common.v1.GiftCardPaymentMethod
 */
export const GiftCardPaymentMethod = proto3.makeMessageType(
  "common.v1.GiftCardPaymentMethod",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "point_of_sale_currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "collect_pin_code", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message common.v1.Mandate
 */
export const Mandate = proto3.makeMessageType(
  "common.v1.Mandate",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "mandate_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "show_acknowledgement", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "acknowledgement_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "mandate_verbiages", kind: "message", T: MandateVerbiage, repeated: true },
    { no: 6, name: "mandate_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Mandate Verbiage details
 *
 * @generated from message common.v1.MandateVerbiage
 */
export const MandateVerbiage = proto3.makeMessageType(
  "common.v1.MandateVerbiage",
  () => [
    { no: 1, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "verbiage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.ThreeDs
 */
export const ThreeDs = proto3.makeMessageType(
  "common.v1.ThreeDs",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "bypass_transaction_amount", kind: "message", T: Money, repeated: true },
    { no: 3, name: "soft_decline_do_not_authenticate_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "not_authenticated_do_not_authorize_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message common.v1.SecuritySettings
 */
export const SecuritySettings = proto3.makeMessageType(
  "common.v1.SecuritySettings",
  () => [
    { no: 1, name: "threeds_settings", kind: "message", T: ThreeDs },
  ],
);

/**
 * @generated from message common.v1.L2L3DataConfig
 */
export const L2L3DataConfig = proto3.makeMessageType(
  "common.v1.L2L3DataConfig",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Settings for Billing Address checkboxes
 *
 * @generated from message common.v1.BillingAddressCollection
 */
export const BillingAddressCollection = proto3.makeMessageType(
  "common.v1.BillingAddressCollection",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "show_billing_same_as_shipping_checkbox", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "collect_cardholder_name", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "collect_account_holder_name", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "collect_country_and_zip", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "collect_address_city_state", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "collect_address_line_2", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Orders on Hpp (Applicable for HPP layout 1 & HPP layout 2 ONLY)
 *
 * @generated from message common.v1.OrdersOnHpp
 */
export const OrdersOnHpp = proto3.makeMessageType(
  "common.v1.OrdersOnHpp",
  () => [
    { no: 1, name: "display_order_summary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "display_shipping_details", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "display_order_confirmation_page", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "back_to_merchant_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "success_redirection_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "failure_redirection_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "display_contact_info", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "display_cart_items", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Details about Fraud Check
 *
 * @generated from message common.v1.FraudCheck
 */
export const FraudCheck = proto3.makeMessageType(
  "common.v1.FraudCheck",
  () => [
    { no: 1, name: "enable_fraud_check", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "fraud_check_timeout_handling_mode", kind: "enum", T: proto3.getEnumType(FraudCheckTimeoutHandlingMode) },
    { no: 3, name: "fraud_check_in_review_handling_mode", kind: "enum", T: proto3.getEnumType(FraudCheckInReviewHandlingMode) },
    { no: 4, name: "fraud_check_data", kind: "enum", T: proto3.getEnumType(FraudCheckData) },
  ],
);

/**
 * Defines the page header settings
 *
 * @generated from message common.v1.PageHeader
 */
export const PageHeader = proto3.makeMessageType(
  "common.v1.PageHeader",
  () => [
    { no: 1, name: "merchant_logo_settings", kind: "message", T: MerchantLogoSettings },
    { no: 2, name: "checkout_title", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "return_to_cart", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "return_to_cart_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Defines the merchant logo settings
 *
 * @generated from message common.v1.MerchantLogoSettings
 */
export const MerchantLogoSettings = proto3.makeMessageType(
  "common.v1.MerchantLogoSettings",
  () => [
    { no: 1, name: "merchant_logo_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "merchant_logo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "merchant_logo_url_mobile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines the notification subscription
 *
 * @generated from message common.v1.NotificationSubscription
 */
export const NotificationSubscription = proto3.makeMessageType(
  "common.v1.NotificationSubscription",
  () => [
    { no: 1, name: "enable_profile_notification", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "enable_token_notification", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "enable_order_notification", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "payment_links_notifications", kind: "message", T: PaymentLinksNotifications },
  ],
);

/**
 * Notifications settings for Pay By Link
 *
 * @generated from message common.v1.PaymentLinksNotifications
 */
export const PaymentLinksNotifications = proto3.makeMessageType(
  "common.v1.PaymentLinksNotifications",
  () => [
    { no: 1, name: "enable_pbl_notification", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "customer_pbl_notifications", kind: "message", T: CustomerPblNotifications },
    { no: 3, name: "merchant_pbl_notifications", kind: "message", T: MerchantPblNotifications },
  ],
);

/**
 * @generated from message common.v1.CustomerPblNotifications
 */
export const CustomerPblNotifications = proto3.makeMessageType(
  "common.v1.CustomerPblNotifications",
  () => [
    { no: 1, name: "enable_payment_link_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "enable_payment_confirmation_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "enable_auto_reminder_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message common.v1.MerchantPblNotifications
 */
export const MerchantPblNotifications = proto3.makeMessageType(
  "common.v1.MerchantPblNotifications",
  () => [
    { no: 1, name: "enable_payment_link_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "enable_payment_confirmation_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message common.v1.CreateMerchantSettingsPayload
 */
export const CreateMerchantSettingsPayload = proto3.makeMessageType(
  "common.v1.CreateMerchantSettingsPayload",
  () => [
    { no: 2, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ui_settings", kind: "message", T: UISettings },
    { no: 4, name: "language_config", kind: "message", T: Struct },
    { no: 5, name: "currency_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "industry_types", kind: "enum", T: proto3.getEnumType(IndustryType), repeated: true },
    { no: 7, name: "product_type", kind: "enum", T: proto3.getEnumType(ProductType), repeated: true },
    { no: 11, name: "supported_payment_gateway_types", kind: "enum", T: proto3.getEnumType(PaymentGatewayType), repeated: true },
    { no: 12, name: "provide_cti_data", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "fraud_check_timeout_handling_mode", kind: "enum", T: proto3.getEnumType(FraudCheckTimeoutHandlingMode) },
    { no: 16, name: "payment_methods", kind: "message", T: PaymentMethods },
    { no: 17, name: "integration_type", kind: "enum", T: proto3.getEnumType(IntegrationType) },
    { no: 18, name: "layout", kind: "enum", T: proto3.getEnumType(Layout) },
    { no: 19, name: "merchant_display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "orders_on_hpp", kind: "message", T: OrdersOnHpp },
    { no: 21, name: "payment_max_retries_allowed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "fraud_check", kind: "message", T: FraudCheck },
    { no: 24, name: "notification_subscription", kind: "message", T: NotificationSubscription },
    { no: 25, name: "abandoned_order_ttl", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "payment_button_name", kind: "enum", T: proto3.getEnumType(PaymentButtonName) },
    { no: 28, name: "address_autocomplete_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "supported_ship_to_country_region", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "single_page_app_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 32, name: "order_mandates", kind: "message", T: Mandate, repeated: true },
    { no: 33, name: "security_settings", kind: "message", T: SecuritySettings },
    { no: 34, name: "page_header", kind: "message", T: PageHeader },
    { no: 35, name: "brand_experience", kind: "message", T: Struct },
    { no: 36, name: "l2_l3_data_config", kind: "message", T: L2L3DataConfig },
    { no: 37, name: "billing_address_country_restriction", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 38, name: "acquirer_tokenization_enabled_indicator", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 39, name: "segment", kind: "message", T: Segment },
    { no: 40, name: "payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 42, name: "tax_integration", kind: "message", T: TaxIntegration },
    { no: 43, name: "surcharge_fee_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 44, name: "merchant_accepted_domains", kind: "message", T: MerchantAcceptedDomains },
  ],
);

/**
 * @generated from message common.v1.TaxIntegration
 */
export const TaxIntegration = proto3.makeMessageType(
  "common.v1.TaxIntegration",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "tax_payer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "default_tax_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * Reference Data Object for Bundle Settings Endpoint MPP
 *
 * @generated from message common.v1.ReferenceData
 */
export const ReferenceData = proto3.makeMessageType(
  "common.v1.ReferenceData",
  () => [
    { no: 1, name: "industry_types", kind: "enum", T: proto3.getEnumType(IndustryType), repeated: true },
    { no: 2, name: "payment_methods", kind: "message", T: ReferenceData_PaymentMethods },
    { no: 3, name: "fraud_check_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "supported_languages", kind: "enum", T: proto3.getEnumType(SupportedLanguages), repeated: true },
    { no: 5, name: "threeds_settings", kind: "message", T: ThreeDs },
    { no: 6, name: "surcharge_fee_supported", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods
 */
export const ReferenceData_PaymentMethods = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods",
  () => [
    { no: 1, name: "ecp", kind: "message", T: ReferenceData_PaymentMethods_ECP },
    { no: 2, name: "card_networks", kind: "message", T: ReferenceData_PaymentMethods_CardNetworks },
    { no: 3, name: "wallet", kind: "message", T: ReferenceData_PaymentMethods_Wallet },
    { no: 4, name: "sepa", kind: "message", T: ReferenceData_PaymentMethods_SEPA },
    { no: 5, name: "pay_by_bank", kind: "message", T: ReferenceData_PaymentMethods_PayByBank },
    { no: 6, name: "alt_mops", kind: "message", T: ReferenceData_PaymentMethods_AltMops },
    { no: 7, name: "gift_card", kind: "message", T: ReferenceData_PaymentMethods_GiftCard },
  ],
  {localName: "ReferenceData_PaymentMethods"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.ECP
 */
export const ReferenceData_PaymentMethods_ECP = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.ECP",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_ECP"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.SEPA
 */
export const ReferenceData_PaymentMethods_SEPA = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.SEPA",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_SEPA"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.CardNetworks
 */
export const ReferenceData_PaymentMethods_CardNetworks = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.CardNetworks",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "values", kind: "enum", T: proto3.getEnumType(CardNetwork), repeated: true },
  ],
  {localName: "ReferenceData_PaymentMethods_CardNetworks"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.Wallet
 */
export const ReferenceData_PaymentMethods_Wallet = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.Wallet",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
  {localName: "ReferenceData_PaymentMethods_Wallet"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.PayByBank
 */
export const ReferenceData_PaymentMethods_PayByBank = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.PayByBank",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_PayByBank"},
);

/**
 * Alternative Payment Methods
 *
 * @generated from message common.v1.ReferenceData.PaymentMethods.AltMops
 */
export const ReferenceData_PaymentMethods_AltMops = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.AltMops",
  () => [
    { no: 1, name: "ali_pay", kind: "message", T: Alipay },
    { no: 2, name: "wechat_pay", kind: "message", T: ReferenceData_PaymentMethods_AltMops_WechatPay },
    { no: 3, name: "giro_pay", kind: "message", T: ReferenceData_PaymentMethods_AltMops_GiroPay },
    { no: 4, name: "sofort", kind: "message", T: ReferenceData_PaymentMethods_AltMops_Sofort },
    { no: 5, name: "trustly", kind: "message", T: ReferenceData_PaymentMethods_AltMops_Trustly },
    { no: 6, name: "ideal", kind: "message", T: ReferenceData_PaymentMethods_AltMops_Ideal },
    { no: 7, name: "paypal", kind: "message", T: ReferenceData_PaymentMethods_AltMops_PayPal },
  ],
  {localName: "ReferenceData_PaymentMethods_AltMops"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.AltMops.AliPay
 */
export const ReferenceData_PaymentMethods_AltMops_AliPay = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.AltMops.AliPay",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_AltMops_AliPay"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.AltMops.WechatPay
 */
export const ReferenceData_PaymentMethods_AltMops_WechatPay = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.AltMops.WechatPay",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_AltMops_WechatPay"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.AltMops.GiroPay
 */
export const ReferenceData_PaymentMethods_AltMops_GiroPay = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.AltMops.GiroPay",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_AltMops_GiroPay"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.AltMops.Sofort
 */
export const ReferenceData_PaymentMethods_AltMops_Sofort = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.AltMops.Sofort",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_AltMops_Sofort"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.AltMops.Trustly
 */
export const ReferenceData_PaymentMethods_AltMops_Trustly = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.AltMops.Trustly",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_AltMops_Trustly"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.AltMops.Ideal
 */
export const ReferenceData_PaymentMethods_AltMops_Ideal = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.AltMops.Ideal",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_AltMops_Ideal"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.AltMops.PayPal
 */
export const ReferenceData_PaymentMethods_AltMops_PayPal = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.AltMops.PayPal",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_AltMops_PayPal"},
);

/**
 * @generated from message common.v1.ReferenceData.PaymentMethods.GiftCard
 */
export const ReferenceData_PaymentMethods_GiftCard = proto3.makeMessageType(
  "common.v1.ReferenceData.PaymentMethods.GiftCard",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "ReferenceData_PaymentMethods_GiftCard"},
);

/**
 * @generated from message common.v1.MerchantSettingsMeta
 */
export const MerchantSettingsMeta = proto3.makeMessageType(
  "common.v1.MerchantSettingsMeta",
  () => [
    { no: 2, name: "settings_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(MerchantSettingsStatus) },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
    { no: 6, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "active_from", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message common.v1.MerchantAcceptedDomains
 */
export const MerchantAcceptedDomains = proto3.makeMessageType(
  "common.v1.MerchantAcceptedDomains",
  () => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "merchant_accepted_domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message common.v1.Experiment
 */
export const Experiment = proto3.makeMessageType(
  "common.v1.Experiment",
  () => [
    { no: 1, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(ExperimentStatus) },
    { no: 5, name: "control_segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "treatment_segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "control_segment_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "start_date", kind: "message", T: Timestamp },
    { no: 9, name: "end_date", kind: "message", T: Timestamp },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
    { no: 12, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message common.v1.ExperimentResult
 */
export const ExperimentResult = proto3.makeMessageType(
  "common.v1.ExperimentResult",
  () => [
    { no: 1, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "currency_code_iso_4217", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "num_orders", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "num_completed_orders", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "total_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "total_completed_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "time_to_complete_histogram", kind: "message", T: TimeToCompleteHistogram },
    { no: 8, name: "experiment_date", kind: "message", T: Date },
    { no: 9, name: "avg_order_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "conversion_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "average_ttc_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "conversion_rate_probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "order_value_probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "completed_order_value_probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "ttc_second_probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 16, name: "std_dev_order_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 17, name: "std_dev_completed_order_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 18, name: "std_dev_ttc_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message common.v1.ExperimentWithResults
 */
export const ExperimentWithResults = proto3.makeMessageType(
  "common.v1.ExperimentWithResults",
  () => [
    { no: 1, name: "experiment", kind: "message", T: Experiment },
    { no: 2, name: "control_segment_experiment_result", kind: "message", T: ExperimentResult },
    { no: 3, name: "treatment_segment_experiment_result", kind: "message", T: ExperimentResult },
    { no: 4, name: "control_segment_experiment_daily_result", kind: "message", T: ExperimentResult, repeated: true },
    { no: 5, name: "treatment_segment_experiment_daily_result", kind: "message", T: ExperimentResult, repeated: true },
  ],
);

/**
 * @generated from message common.v1.CreateExperimentPayload
 */
export const CreateExperimentPayload = proto3.makeMessageType(
  "common.v1.CreateExperimentPayload",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "control_segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "treatment_segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "control_segment_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "start_date", kind: "message", T: Timestamp },
    { no: 7, name: "end_date", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message common.v1.TimeToCompleteHistogram
 */
export const TimeToCompleteHistogram = proto3.makeMessageType(
  "common.v1.TimeToCompleteHistogram",
  () => [
    { no: 1, name: "minutes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "num_orders", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

